var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-tab-pane", { attrs: { name: "customers" } }, [
    _c("div", { staticClass: "row gutter-x-md justify-start" }, [
      _c("div", { staticClass: "col-md-3 col-12" }, [
        _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
          _vm._v(_vm._s(_vm.$t("customer_number")))
        ]),
        _c("p", { staticClass: "text-faded" }, [
          _vm._v(_vm._s(_vm.$t("customer_number_hint")))
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-md-9 col-12" },
        [
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("customer_number_format"),
                labelWidth: 3,
                error: _vm.errors.has("customerNumberFormat"),
                "error-label": _vm.errors.first("customerNumberFormat")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|min:1|max:255",
                    expression: "'required|min:1|max:255'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "customerNumberFormat",
                  placeholder: _vm.$t("customer_number_format")
                },
                model: {
                  value: _vm.formData.customerNumberFormat,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "customerNumberFormat", $$v)
                  },
                  expression: "formData.customerNumberFormat"
                }
              }),
              _c(
                "div",
                { staticClass: "row items-center q-mt-xs" },
                [
                  _c("q-tooltip", {
                    attrs: { anchor: "top left" },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("customer_number_format_hint") +
                          _vm.customerNumberFormatExample
                      )
                    }
                  }),
                  _c("q-icon", { attrs: { name: "info", color: "grey-5" } }),
                  _c("span", { staticClass: "q-ml-xs text-grey-5" }, [
                    _vm._v(_vm._s(_vm.$tc("placeholder", 2)))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("next_customer_number"),
                labelWidth: 3,
                error: _vm.errors.has("currentCustomerNumber"),
                "error-label": _vm.errors.first("currentCustomerNumber")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|min:1|max:45",
                    expression: "'required|min:1|max:45'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "currentCustomerNumber",
                  placeholder: _vm.$t("next_customer_number")
                },
                model: {
                  value: _vm.formData.currentCustomerNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "currentCustomerNumber", $$v)
                  },
                  expression: "formData.currentCustomerNumber"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("next_account_receivable_number"),
                labelWidth: 3,
                error: _vm.errors.has("currentCustomerNumber"),
                "error-label": _vm.errors.first("currentCustomerNumber")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|min:1|max:45",
                    expression: "'required|min:1|max:45'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "currentAccountsReceivableNumber",
                  placeholder: _vm.$t("next_account_receivable_number")
                },
                model: {
                  value: _vm.formData.currentAccountsReceivableNumber,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.formData,
                      "currentAccountsReceivableNumber",
                      $$v
                    )
                  },
                  expression: "formData.currentAccountsReceivableNumber"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("next_account_payable_number"),
                labelWidth: 3,
                error: _vm.errors.has("currentCustomerNumber"),
                "error-label": _vm.errors.first("currentCustomerNumber")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|min:1|max:45",
                    expression: "'required|min:1|max:45'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "currentAccountsPayableNumber",
                  placeholder: _vm.$t("next_account_payable_number")
                },
                model: {
                  value: _vm.formData.currentAccountsPayableNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "currentAccountsPayableNumber", $$v)
                  },
                  expression: "formData.currentAccountsPayableNumber"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "row justify-end" },
      [
        _c(
          "q-btn",
          {
            attrs: { type: "submit", color: "primary" },
            on: { click: _vm.handleSave }
          },
          [_vm._v(_vm._s(_vm.$t("save")))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }